import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { LicenseConnectorsListModule } from '@portal-core/licenses/components/license-connectors/license-connectors-list/license-connectors-list.module';
import { LicenseConnectorsSettingsModule } from '@portal-core/licenses/components/license-connectors/license-connectors-settings/license-connectors-settings.module';
import { LicenseConnectorsComponent } from '@portal-core/licenses/components/license-connectors/license-connectors/license-connectors.component';


@NgModule({
  declarations: [
    LicenseConnectorsComponent
  ],
  imports: [
    CommonModule,
    LicenseConnectorsListModule,
    LicenseConnectorsSettingsModule
  ],
  exports: [
    LicenseConnectorsComponent
  ]
})
export class LicenseConnectorsModule { }
